import React from "react";
import Button from "../utils/Button";
import useShopStore from "../store/useShopStore";
import useAppStore from "../store/useAppStore";
import { toast } from "react-toastify";

export default function AddToCartButton(props) {
  const { updateCart } = useShopStore((state) => state);

  const addToCartHandler = () => {
    updateCart(props.id);
    useAppStore.setState({ notify: "Product has been added to Cart 😍" });

    toast(useAppStore.getState().notify);
  };

  return (
    <>
      <Button style={props.style} onClick={addToCartHandler}>
        Add to cart
      </Button>
    </>
  );
}
